<div #aboutContainer class="flex flex-col gap-2 p-4 text-sm" [ngClass]="{ 'hover:cursor-pointer' : isOwnProfile && !isEditing }">
    <div #formattedAbout (click)="onEditClicked()" class="flex flex-col gap-2 ooc" [ngClass]="{ 'hidden' : isEditing }">
        @if (isOwnProfile) {
            <div class="text-center text-slate-400">
                Click to enter your profile information.
            </div>
        } @else {
            <div class="text-center text-slate-400">
                This user prefers to maintain an air of mystery.
            </div>
        }
    </div>
    @if (hasUnsavedChanges && !isEditing) {
        <div class="text-slate-500 italic text-xs">
            Note: There are unsaved changes. Please click 'Save' or 'Cancel' when done.
        </div>
    }
    <div class="flex flex-col gap-2" [ngClass]="{ 'hidden' : !isEditing }">
        <div>
            <textarea #editInput (input)="onInputText()" class="w-full p-2 rounded-sm shadow-sm" rows="5" [disabled]="isSaving">{{ editedText }}</textarea>
        </div>
        <div class="flex flex-row gap-2 pr-1 text-slate-500 text-xs">
            <div class="grow">
                Tip: Use <a href="https://www.markdownguide.org/basic-syntax/" class="text-ponder-link hover:text-ponder-linkhover">markdown</a> to format your profile!
            </div>
            @if (!textLengthWarning && !textLengthError) {
                <div>{{ safeTextLength() }} / {{ maxLength }}</div>
            } @else if(textLengthError) {
                <div class="text-red-600">{{ safeTextLength() }} / {{ maxLength }}</div>
                <div class="text-red-600">(!)</div>
            } @else {
                <div class="text-red-400">{{ safeTextLength() }} / {{ maxLength }}</div>
            }
        </div>
        
        @if (savingFailed) {
            <div class="text-right text-red-600">
                Something went wrong! Please try again.
            </div>
        }
        <div class="flex flex-row gap-2 text-sm items-center justify-end">
            @if (isSaving) {
                <div class="p-1 pr-4">
                    <busy-spin></busy-spin>
                </div>
            } @else {
                <button (click)="onCancelClicked()" class="justify-center w-[10ch] flex flex-row items-center gap-1 group bg-white p-1 min-h-8 rounded-sm shadow-sm stroke-ponder-light hover:text-ponder-link hover:stroke-ponder-link hover:cursor-pointer border border-transparent hover:border-ponder-link">
                    Cancel
                </button>
                <button (click)="onSaveClicked()" class="justify-center w-[10ch] flex flex-row items-center gap-1 group bg-white p-1 min-h-8 rounded-sm shadow-sm stroke-ponder-light hover:text-ponder-link hover:stroke-ponder-link hover:cursor-pointer border border-transparent hover:border-ponder-link disabled:text-slate-500 disabled:hover:text-slate-500 disabled:hover:cursor-default disabled:hover:border-transparent" [disabled]="textLengthError">
                    Save
                </button>
            }
        </div>
    </div>
</div>